import FeatherIcon from "feather-icons-react";
import React, { FC } from "react";
import { CompanyListItemAdminDto, UserRole } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";

import { Dropdown, Stack, Typography } from "@components/base";
import { Chip } from "@components/common";
import { useGenerateSsoToken } from "@api";

interface CompanyUsers {
  company: CompanyListItemAdminDto;
}

const CompanyUsers: FC<CompanyUsers> = ({ company }) => {
  const { t } = useTranslation();
  const { generateSsoTokenAsync } = useGenerateSsoToken();

  const handleSso = async (userId: string): Promise<void> => {
    const ssoToken = await generateSsoTokenAsync(userId);
    const ssoUrl = `${window.location.origin}/sso-login?token=${ssoToken}`;

    await navigator.clipboard.writeText(ssoUrl);
    enqueueSnackbar(t("admin.ssoUrlCopied", "SSO URL copied to clipboard"), {
      variant: "success",
    });
  };

  return (
    <Dropdown
      button={{
        title: <FeatherIcon icon="users" width="16" height="16" />,
        variant: "text",
        size: "small",
      }}
      options={company.users.map((user) => ({
        id: user.id,
        title: (
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <FeatherIcon icon="key" width="16" height="16" />
              <Typography>{user.name}</Typography>
            </Stack>
            <Chip
              label={t(`roles.${UserRole[user.role].toLowerCase()}`)}
              type={user.role as UserRole}
              size="small"
            />
          </Stack>
        ),
      }))}
      onSelect={(option) => handleSso(option.id as string)}
    />
  );
};

export default CompanyUsers;
